import { useState, useEffect } from "react";
import { useDataProvider } from "react-admin";

/**
 *
 *
 *
 * @returns { roles, loading, error, changePassword };
 */
function useRoles() {
  const [roles, setRoles] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const dataProvider = useDataProvider();

  useEffect(() => {
    async function fetchAll() {
      try {
        const roles = await dataProvider.getList("merchant-roles", {});

        setRoles(roles.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setError(error);
      }
    }
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { roles, loading, error };
}

export default useRoles;
